import { AppConfigInfo } from "../redux/slice/commonSlice";
import { InterceptorOption } from "../types/CommonTypes";
import {
    AUTOCOMPLETE_ADDRESS,
    CHECK_VERSION_URL,
    EDIT_APP_CONFIG_URL,
    FETCH_ALL_PAYERS,
    FETCH_BILLERS_URL, FETCH_MACS_URL, FETCH_PRODUCT_WITH_PRICE_URL, GET_ALL_AGENCIES_URL,
    GET_APP_CONFIG_LIST_URL,
    GET_DOCUMENT_PUBLIC_URL,
    GET_DOCUMENT_URL,
    GET_MANUFACTURERS_URL, GET_MANUFACTURERS_URL_FOR_ANCILLARY_PRODCUT, GET_PATIENT_LOOKUP_BY_USER_ROLE_URL, GET_PHARMACIES_URL, GET_PRACTICE_LOOK_UP_BY_USER_ROLE_URL, PLACE_DETAILS, SEARCH_PRACTICES_URL
} from "./URL";
import { http } from "./http";

export const getMacsList = async () => {
    const response = await http.get(FETCH_MACS_URL);
    return response;
};
export const getAllPayersList = async () => {
    const response = await http.get(FETCH_ALL_PAYERS);
    return response;
};
export const getDocumentByDocumentId = async (docId: number) => {
  try {
    const response = await http.get(`${GET_DOCUMENT_URL}/${docId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDocumentByDocumentIdPublic = async (docId: number) => {
    try {
      const response = await http.get(`${GET_DOCUMENT_PUBLIC_URL}/${docId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

//cs-433
export const getAppConfigList = async () => {
    const response = await http.get(GET_APP_CONFIG_LIST_URL);
    return response;
};
export const editAppConfigData = async (data:AppConfigInfo) => {
    try{
        const response = await http.post(EDIT_APP_CONFIG_URL, data);
        return response;
    }
    catch(error){
        throw error;
    }
};
//

// CS-1112 - START
export const autocompleteAddress = async (data:any, interceptorOption: InterceptorOption | undefined, headers: Record<string, string>) => {
    try{
        const response = await http.post(AUTOCOMPLETE_ADDRESS+`?input=${data}`,undefined,{
            headers: {
                ...headers,
              },
        },interceptorOption);
        return response;
    }
    catch(error){
        throw error;
    }
};

export const addressDetails = async (data:any ,interceptorOption: InterceptorOption | undefined) => {
    try{
        const response = await http.get(PLACE_DETAILS+`?placeId=${data}`,undefined,interceptorOption);
        return response;
    }
    catch(error){
        throw error;
    }
};
// CS-1112 - END

export const getManufacturersList = async () =>{
    const response = await http.get(GET_MANUFACTURERS_URL);
    return response;
};

export const getManufacturersListSkipLoader = async (headers: Record<string, string>) =>{
    const response = await http.get(GET_MANUFACTURERS_URL, { headers: {...headers} });
    return response;
};

// CS-2075 — manufacturers flagged as pharmacies, for the pharmacy dropdowns
export const getPharmaciesListSkipLoader = async (headers: Record<string, string>) =>{
    const response = await http.get(GET_PHARMACIES_URL, { headers: {...headers} });
    return response;
};

export const getAncillaryProductManufacturersList = async () =>{
    const response = await http.get(GET_MANUFACTURERS_URL_FOR_ANCILLARY_PRODCUT);
    return response;
};

export const getProductList = async () => {
    const response = http.get(FETCH_PRODUCT_WITH_PRICE_URL);
    return response;
};

export const getPracticeList = async (data:any) => {
    const response = await http.post(SEARCH_PRACTICES_URL, data)
    return response;
};

export const getAllAgenciesList = async (skipLoader: boolean = false) =>{
    const response = skipLoader
      ? await http.get(GET_ALL_AGENCIES_URL, { headers: { "x-skip-loader": "true" } })
      : await http.get(GET_ALL_AGENCIES_URL);
    return response;
};

export const findAllBillers = async (activeBillersOnly?: boolean) => {
    try {
        const response = await http.get(`${FETCH_BILLERS_URL}?activeBillersOnly=${activeBillersOnly}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const findAppVersion = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(CHECK_VERSION_URL,{
            headers: {
                ...headers,
              },
        });
        return response;
    } catch (error) {
        throw error;
    }
}


//CS-1732 - Start
export const fetchPracticeLookUpByUserRole = async(
    activePracticeOnly?: boolean,
    productId?: number,
    executedOnly?: boolean,
    skipLoader: boolean = false
)=>{
    try {
        let url = `${GET_PRACTICE_LOOK_UP_BY_USER_ROLE_URL}`;
        const params: string[] = [];
        
        if (activePracticeOnly !== undefined && activePracticeOnly !== null) {
            params.push(`isActivePracticeOnly=${activePracticeOnly}`);
        }
        if (executedOnly !== undefined && executedOnly !== null) {
            params.push(`executedOnly=${executedOnly}`);
        }
        if (productId !== undefined && productId !== null) {
            params.push(`productId=${productId}`);
        }
        
        if (params.length > 0) {
            url += '?' + params.join('&');
        }
        const response = await http.get(url, {
            headers: { "x-skip-loader": skipLoader.toString() },
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const fetchPatientLookUpByUserRole = async(activePatientOnly?:boolean, practiceId?:number)=>{
    try {
        let url = `${GET_PATIENT_LOOKUP_BY_USER_ROLE_URL}`;
        const params: string[] = [];
        
        if (activePatientOnly !== undefined && activePatientOnly !== null) {
            params.push(`isActivePatientOnly=${activePatientOnly}`);
        }
        if (practiceId !== undefined && practiceId !== null) {
            params.push(`practiceId=${practiceId}`);
        }
        
        if (params.length > 0) {
            url += '?' + params.join('&');
        }
        const response = await http.get(url);
        return response;
    } catch (error) {
        throw error;
    }
}